var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"factionbuttons"},_vm._l((_vm.cButtons),function(button){return _c('FButton',_vm._b({key:button._id,class:`btn ${_vm.btnClass}`,attrs:{"disabled":_vm.disabled},nativeOn:{"click":function($event){return _vm.onButtonClick(button.action)}}},'FButton',{ ...button, _id: null, action: null },false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }